






































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as api from '@/api/api';
import * as def from '@/common/definitions';

@Component({
  components: {
  },
})
export default class AllianceView extends Vue {
  @Prop() private diplomacy?: api.CountryAlliance;
  @Prop() private changingValue?: api.CountryAlliance;
  @Prop() private status!: def.CountryAllianceStatus;
  @Prop() private newData!: api.CountryAlliance;
  @Prop() private isSending!: boolean;
  @Prop() private canEdit!: boolean;
  @Prop() private isShow!: boolean;
  @Prop() private canReligion!: boolean;

  @Watch('isShow')
  private onIsShowChanged() {
    if (this.isShow) {
      this.newData.status = -1;
    }
  }

  @Watch('diplomacy')
  private onDiplomacyChanged() {
    if (this.isShow && this.diplomacy) {
      this.newData.isPublic = this.diplomacy.isPublic;
      this.newData.canMissionary = this.diplomacy.canMissionary;
      this.newData.breakingDelay = this.diplomacy.breakingDelay;
      this.newData.memo = this.diplomacy.memo;
    }
  }

  private created() {
    this.onIsShowChanged();
    this.onDiplomacyChanged();
  }
}
